'use strict';

/* global $ */

import { interfaceName } from './settings';

import { Goal } from './modules/goal';
import { Responsive } from './modules/responsive';
import { Sliders } from './modules/sliders';
import { Scroll } from './modules/smooth-scroll';
import { Aks } from './modules/aksses';
import { Embroidery } from './modules/embroidery';
import { AjaxForm } from './modules/ajax-form';
import { AjaxCart } from './modules/ajax-cart';
import { Tab } from './modules/tab';
import { Material } from './modules/material';
import { Articles } from './modules/articles';
import { equipment } from './modules/equipment';
import { Gallery } from './modules/gallery';
import { headerMain } from './modules/header';
import { selectMark } from './modules/selectmark';
import { cartDelivery } from './modules/cart-delivery';
import { secondSlider } from './modules/second-slider';
import { cartOrder } from './modules/cart-order';
import { cartPayment } from './modules/cart-payment';
import { AjaxLoadPage } from './modules/ajax-loadpage';
import { Ymap } from './modules/yandexMap';
import { ShowMore } from './modules/more';
import { FlexLink } from './modules/flexlink';
import { AjaxUpdate } from 'modules/ajax-update';
import { JuxtaPose } from 'modules/juxtapose';
import { Cookie } from 'modules/cookie';

class Proj {
    constructor() {
        this.init();
    }
    init() {
        this.interfaceName = interfaceName;
        Tab();
        Articles();
        equipment();
        selectMark();
        secondSlider();
        this.sliders = new Sliders();
        this.gallery = new Gallery();
        this.scroll = new Scroll();
        this.emb = new Embroidery();
        this.aks = new Aks();
        this.ajaxForm = new AjaxForm();
        this.ajaxCart = new AjaxCart();
        this.yMap = new Ymap();
        this.goal = new Goal({
            goals: [
                {
                    selector: '.js-goal__link',
                    event: 'click',
                    handler() {
                        $(window).trigger('goal.main', $(this).data());
                    }
                }, {
                    selector: '.js-goal__form',
                    event: 'submit',
                    handler() {
                        $(window).trigger('goal.main', $(this).data());
                    }
                }
            ]
        });

        this.responsive = new Responsive();
        Material();
        headerMain();
        cartDelivery();
        cartOrder();
        cartPayment();
        this.ajaxLoadPage = new AjaxLoadPage();
        this.upd = new AjaxUpdate();
        this.ShowMore = new ShowMore();
		this.cookie = new Cookie();
        this.FlexLink = new FlexLink();
        this.JuxtaPose = new JuxtaPose();
    }
}


$(document).ready(function(){
  window.proj = new Proj();
})
